
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import styled from "styled-components";
import Btn from "../../shared/button/Btn";
import PageTopTitle from "../../shared/PageTopTitle";
import { showModal } from "../../../features/modal/modalSlice";
import { getUyeMeslekiYeterlilik, piyasaBilgisiGetir } from "../../../features/uyelerAraclar/uyelerAraclarSlice";
import { useScrollLock } from "../../../hooks/useScrollLock";

const ModalContainer = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 26;

  .modal {
    width: 600px;
    height: auto;
    color: ${({ theme }) => theme.mainTextColor};
    background-color: ${({ theme }) => theme.mainBgColor};
    border: 1px solid;
    border-color: ${({ theme }) => theme.mainBorderColor};
    padding-top: 20px;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;

    .content {
      padding: 40px 0;
      width: 800px;
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 20px;
    }
  }
`;

const AdminUyeItemOptionsModal = () => {
  const dispatch = useDispatch();

  const location = useLocation();
  const { uyeItemData } = useSelector((state) => state.admin2);

  const { modalLocation } = useSelector((state) => state.modal);
  const { lockScroll, unlockScroll } = useScrollLock();

  useEffect(() => {
    if (uyeItemData.id) {
      dispatch(piyasaBilgisiGetir(uyeItemData.id));
    }
  }, [uyeItemData.id]);
  
  //! bu modal açıldığnda ekran ı lock lamak için
  useEffect(() => {
    lockScroll();

    return () => {
      unlockScroll();
    };
  }, [lockScroll, unlockScroll]);

  //! bu başka bir sayfaya geçildiğinde modal ı kapatmak için
  useEffect(() => {
    if (location.pathname !== modalLocation) {
      dispatch(showModal(null));
    }
  }, [dispatch, location.pathname, modalLocation]);


  return (
    <ModalContainer onClick={() => dispatch(showModal(null))}>
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <PageTopTitle title={"Üye İşlemleri"} />
        <div className="content">
        {/* <Btn
            color={"#E85546"}
            background={"#0EAC00"}
            width="280px"
            radius={"10px"}
            fontSize="14px"
            handleClick={() => {
              dispatch(showModal("adminUyeGuncelle"));
            }}
          >
            Üyeyi Güncelle
          </Btn>
          <Btn
            color={"#E85546"}
            background={"#0EAC00"}
            width="280px"
            radius={"10px"}
            fontSize="14px"
            handleClick={() => {
              dispatch(showModal("adminUyeDoc"));
            }}
          >
            Üye Belgeleri
          </Btn>
          <Btn
            color={"#E85546"}
            background={"#0EAC00"}
            width="280px"
            radius={"10px"}
            fontSize="14px"
            handleClick={() => {}}
          >
            Üye Araçları
          </Btn> */}
          {/* {
            uyeItemData.surucuVarYok &&
            <Btn
              color={"#E85546"}
              background={"#0EAC00"}
              width="280px"
              radius={"10px"}
              fontSize="14px"
              handleClick={() => dispatch(showModal("adminUyeninSuruculer"))}
            >
              Üyenin Sürücüleri
            </Btn>
          } */}
          <Btn
            color={"#E85546"}
            background={"#0EAC00"}
            width="280px"
            radius={"10px"}
            fontSize="14px"
            handleClick={() => {
              dispatch(showModal("adminAddUyeSurucu"));
            }}
          >
            Sürücü Ekle
          </Btn>
          {/* <Btn
            color={"#E85546"}
            background={"#0EAC00"}
            width="280px"
            radius={"10px"}
            fontSize="14px"
            handleClick={() => {
              dispatch(showModal("uyeCalismaSekliYerleri"));
            }}
          >
            Çalışma Şekli ve Çalışılan Yerler
          </Btn> */}

          {/* <Btn
            color={"#E85546"}
            background={"#FF0000"}
            width="280px"
            radius={"10px"}
            fontSize="14px"
            handleClick={(e) => {
              e.stopPropagation();
              dispatch(getUyeninBagliOlduguUyeler(uyeItemData.id));
              dispatch(showModal("uyeIsvereni"));
            }}
          >
            İş Vereni
          </Btn> */}
          <Btn
            color={"#E85546"}
            background={"#FF0000"}
            width="280px"
            radius={"10px"}
            fontSize="14px"
            handleClick={(e) => {
              e.stopPropagation();
              dispatch(getUyeMeslekiYeterlilik(uyeItemData.tckn));
              dispatch(showModal("uyeMeslekiYeterlilik"));
            }}
          >
            SRC Sorgula
          </Btn>
          {/* <Btn
            color={"#E85546"}
            background={"#FF0000"}
            width="280px"
            radius={"10px"}
            fontSize="14px"
            handleClick={() => {}}
          >
            Üyeyi Sil
          </Btn> */}
          <Btn
            color={"#E85546"}
            background={"transparent"}
            width="280px"
            radius={"10px"}
            fontSize="14px"
            handleClick={() => dispatch(showModal(null))}
          >
            Geri Dön
          </Btn>
        </div>
      </div>
    </ModalContainer>
  );
};

export default AdminUyeItemOptionsModal;